import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box, styled } from '@mui/material';

export const StyledSectionTsoWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['selectDevice'].includes(prop as string),
})(({ selectDevice }: { selectDevice?: boolean }) => {
  return {
    width: `calc(100%-${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xs})`,
    maxWidth: '32rem',
    display: 'flex',
    padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xs} ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xs} ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xs} 0`,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: selectDevice ? '4px' : tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xs,
    alignSelf: 'stretch',
    borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
    background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_lt,
  };
});
export const StyledLineWrapper = styled(Box)(() => {
  return {
    width: '100%',
    maxWidth: '32rem',
    display: 'flex',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xs,
  };
});

export const StyledButtonWrapper = styled(Box)(() => {
  return {
    paddingTop: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_12,
    display: 'flex',
    width: '100%',
    maxWidth: '32rem',

    justifyContent: 'flex-end',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
  };
});

export const StyledChartWrapper = styled(Box)(() => {
  return {
    width: '100%',

    display: 'flex',
    flexDirection: 'column',

    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_24,
    paddingTop: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32,
  };
});
export const StyledTitleWrapper = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_8,
    padding: '0',
  };
});

export const StyledTitleAndActions = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  };
});

export const StyledActionSection = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
    justifyContent: 'flex-end',
  };
});

export const StyledZoomContainer = styled(Box)(() => {
  return {
    display: 'flex',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  };
});
// Chart
export const StyledChartContainer = styled(Box)(() => {
  return {
    width: '77rem',
    height: '8rem',
    maxHeight: '8rem',
    display: 'flex',
    gap: '0.75rem',
    backgroundColor: tsoPqTheme.palette.background.other.color_other_background_white,
    borderRadius: '0.35rem',
    padding: '0.75rem',
  };
});
export const StyledChartLabel = styled(Box)(() => {
  return {
    width: '11.5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_8,
  };
});

export const StyledChartLabelChip = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  };
});

export const StyledChartLabelTypograpgies = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_4,
  };
});

export const StyledChartLabelPointAndSubstation = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  };
});
